import { create } from 'zustand'
import axios from 'axios'

export const API_SLUG = 'ReceiveScanLog'

export interface ReceiveScanLog {
  id: number
  projectId: number | null
  inventoryId: number | null
  inventoryCode: string
  inventoryCodeD365: string | null
  serialType: string | null
  serialTypeSource: string | null
  status: string
  errorReason: string | null
  scannedByUserId: string | null
  scannedByFullName: string | null
  scannedByUsername: string | null
  ipAddress: string | null
  userAgent: string | null
  createdAt: string
}

export interface ReceiveScanLogQuery {
  page: number
  pageSize: number
  projectId?: number
  status?: string
  inventoryCode?: string
  from?: string
  to?: string
  sortBy?: string
  order?: string
}

export interface ReceiveScanLogStore {
  data: ReceiveScanLog[]
  totalCount: number
  loading: boolean
  error?: any
  getAll: (query: ReceiveScanLogQuery) => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const useReceiveScanLogStore = create<ReceiveScanLogStore>(set => ({
  data: [],
  totalCount: 0,
  loading: false,
  error: undefined,
  getAll: async query => {
    set({ loading: true })

    const params: Record<string, any> = {}
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value
      }
    })

    try {
      const response = await axios.get(`/${API_SLUG}`, { params })
      set({
        data: response.data?.data ?? [],
        totalCount: response.data?.totalCount ?? 0,
        loading: false,
      })

      return { success: true, data: response.data }
    } catch (error: any) {
      set({ loading: false, error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  clearState: () => set({ data: [], totalCount: 0, loading: false, error: undefined }),
}))
